<template>
    <div>
        <SideBar
            :value="sidemenu"
            ref="sidebar"
            :closeOnClick="true"
            :mode="'inner'"
            @onClose="onClose"
        >
            <div slot="header" class="header-sidebar"></div>
            <div slot="body">
                <div v-if="isAuthenticated">
                    <MenuItem to="/" icon="fa-home" index="/">{{$t('sideMenu.home')}}</MenuItem>
                    <MenuGroup
                        v-if="claims.planning.read || claims.annualCatalogProject.read || claims.annualCatalog.read"
                        icon="fa-solar-panel"
                        :title="$t('sideMenu.planning')"
                    >
                        <div slot="children">
                            <MenuItem
                                v-if="claims.planning.read"
                                to="/planning"
                                icon="fa-solar-panel"
                                index="/planning"
                            >{{$t('sideMenu.planning')}}</MenuItem>
                            <MenuItem
                                v-if="claims.annualCatalogProject.read"
                                to="/annualCatalogProject/"
                                icon="fa-project-diagram"
                                index="/annualCatalogProject"
                            >{{$t('sideMenu.annualCatalogProject')}}</MenuItem>
                            <MenuItem
                                v-if="claims.annualCatalog.read"
                                to="/annualcatalog/list"
                                icon="fa-calendar-alt"
                                index="/annualcatalog/list"
                            >{{$t('sideMenu.annualCatalog')}}</MenuItem>
                            <MenuItem
                                v-if="claims.planning.read"
                                to="/organizationalProposals"
                                icon="fa-sitemap"
                                index="/organizationalProposals"
                            >{{$t('organizationalProposals.title')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuItem
                        v-if="claims.event.read"
                        to="/registers/events"
                        icon="fa-calendar-check"
                        index="/registers/events"
                    >{{$t('sideMenu.events')}}</MenuItem>
                    <MenuGroup
                        icon="fa-users"
                        :title="$t('sideMenu.users')"
                        v-if="claims.lecturer.read || claims.nijEmployee.read || claims.mentor.read || claims.participant.read"
                    >
                        <div slot="children">
                            <MenuItem
                                v-if="claims.lecturer.read"
                                to="/registers/lectors"
                                icon="fas fa-chalkboard-teacher"
                                index="/registers/lectors"
                            >{{$t('sideMenu.lectors')}}</MenuItem>
                            <MenuItem
                                v-if="claims.nijEmployee.read"
                                to="/registers/employee"
                                icon="fas fa-briefcase"
                                index="/registers/employee"
                            >{{$t('sideMenu.employees')}}</MenuItem>
                            <MenuItem
                                v-if="claims.mentor.read"
                                to="/registers/mentor"
                                icon="fas fa-user-shield"
                                index="/registers/mentor"
                            >{{$t('sideMenu.mentors')}}</MenuItem>
                            <MenuItem
                                v-if="claims.participant.read"
                                to="/registers/participants"
                                icon="fa-user-graduate"
                                index="/registers/participants"
                            >{{$t('sideMenu.participants')}}</MenuItem>
                            <MenuItem
                                v-if="claims.participant.read"
                                to="/registers/allAppearances"
                                icon="fas fa-list"
                                index="/registers/allAppearances"
                            >{{$t('sideMenu.allAppearances')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuGroup
                        v-if="claims.agenda.read"
                        icon="fa-door-open"
                        :title="$t('sideMenu.rooms')"
                    >
                        <div slot="children">
                            <MenuItem
                                to="/hallsCalendar"
                                icon="fa-calendar-alt"
                                index="/hallsCalendar"
                            >{{$t('sideMenu.calendar')}}</MenuItem>
                            <MenuItem
                                to="/hallAgenda"
                                icon="fa-list"
                                index="/hallAgenda"
                            >{{$t('sideMenu.agenda')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuGroup
                        v-if="claims.tasks.read || claims.signingProcedureFiling.read"
                        icon="fa-tasks"
                        :title="$tc('sideMenu.tasksAndCoordinations', 2)"
                    >
                        <div slot="children">
                            <MenuItem
                                v-if="claims.tasks.read"
                                to="/tasks"
                                icon="fa-check"
                                index="/tasks"
                            >{{$t('sideMenu.tasks')}}</MenuItem>
                            <MenuItem
                                v-if="claims.tasks.read"
                                to="/coordinations"
                                icon="fa-sitemap"
                                index="/coordinations"
                            >{{$t('sideMenu.coordinations')}}</MenuItem>
                            <MenuItem
                                v-if="claims.tasks.read"
                                to="/signatures"
                                icon="fa-file-signature"
                                index="/signatures"
                            >{{$t('sideMenu.signing')}}</MenuItem>
                            <MenuItem
                                v-if="claims.signingProcedureFiling.read"
                                to="/signingProcedureFiling"
                                icon="fa-file-signature"
                                index="/signingProcedureFiling"
                            >{{$t('sideMenu.signingProcedureFiling')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuItem
                        v-if="claims.certificateAdministration.read"
                        to="/certificates"
                        icon="fa-certificate"
                        index="/certificates"
                    >{{$t('sideMenu.certificates')}}</MenuItem>
                    <MenuGroup
                        v-if="claims.eventBudget.read"
                        icon="fas fa-coins"
                        :title="$t('registers.events.budget.title')"
                    >
                        <div slot="children">
                            <MenuItem
                                v-if="claims.eventBudget.read"
                                to="/budgetModule"
                                icon="fa-euro-sign"
                                index="/budgetModule"
                            >{{$t('sideMenu.budgetModule')}}</MenuItem>
                            <MenuItem
                                v-if="claims.eventBudget.read"
                                to="/budgetReport"
                                icon="fas fa-money-check"
                                index="/budgetReport"
                            >{{$t('sideMenu.budgetModuleReport')}}</MenuItem>
                            <MenuItem
                                v-if="claims.eventBudget.read"
                                to="/registers/budgetTemplate"
                                icon="fa-file-invoice-dollar"
                                index="/registers/budgetTemplate"
                            >{{$t('sideMenu.budgetTemplate')}}</MenuItem>
                            </div>
                    </MenuGroup>
                    <MenuGroup
                        v-if="claims.organizersRegister.read || claims.venuesRegister.read
                            || claims.accommodationPlacesRegister.read || claims.projectsRegister.read
                            || claims.publicOrdersRegister.read || claims.activitiesRegister.read
                            || claims.thematicAreasRegister.read || claims.eventThemesRegister.read
                            || claims.institutionsRegister.read || claims.nijPositionsRegister.read
                            || claims.contractsRegister.read || claims.organizationalModelsRegister.read
                            || claims.rankingCriteriaRegister.read"
                        icon="fa-list-ol"
                        :title="$t('sideMenu.registers')"
                    >
                        <div slot="children">
                            <MenuItem
                                v-if="claims.organizersRegister.read"
                                to="/registers/organizers"
                                index="/registers/organizers"
                            >{{$t('organizers')}}</MenuItem>
                            <MenuItem
                                v-if="claims.venuesRegister.read"
                                to="/registers/places"
                                index="/registers/places"
                            >{{$t('places.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.accommodationPlacesRegister.read"
                                to="/registers/accommodationPlaces"
                                index="/registers/accommodationPlaces"
                            >{{$t('registers.accommodation.menuTitle')}}</MenuItem>
                            <MenuItem
                                v-if="claims.projectsRegister.read"
                                to="/registers/projects"
                                index="/registers/projects"
                            >{{$t('project.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.publicOrdersRegister.read"
                                to="/registers/publicOrders"
                                index="/registers/publicOrders"
                            >{{$t('registers.publicOrder.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.activitiesRegister.read"
                                to="/registers/activities"
                                index="/registers/activities"
                            >{{$t('activity.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.thematicAreasRegister.read"
                                to="/registers/thematicAreas"
                                index="/registers/thematicAreas"
                            >{{$t('thematicArea.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.eventThemesRegister.read"
                                to="/registers/theme"
                                index="/registers/theme"
                            >{{$t('registers.theme.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.institutionsRegister.read"
                                to="/registers/institutions"
                                index="/registers/institutions"
                            >{{$t('institution.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.nijPositionsRegister.read"
                                to="/registers/administrativePositions"
                                index="/registers/administrativePositions"
                            >{{$t('administrativePosition.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.contractsRegister.read"
                                to="/registers/externalSuppliers"
                                index="/registers/externalSuppliers"
                            >{{$t('externalSupplier.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.organizationalModelsRegister.read"
                                to="/organizationalModels"
                                icon="fa-sitemap"
                                index="/organizationalModels"
                            >{{$t('organizationalModel.titles')}}</MenuItem>
                            <MenuItem
                                v-if="claims.rankingCriteriaRegister.read"
                                to="/registers/rankingCriteria"
                                index="/registers/rankingCriteria"
                            >{{$t('sideMenu.rankingCriteria')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuItem
                        v-if="claims.reports.read"
                        icon="fa-chart-pie"
                        index="/reports"
                        emit-click
                        @click="navigateToReports"
                    >{{$t('sideMenu.reports')}}</MenuItem>
                    <MenuGroup
                        icon="fa-cog"
                        :title="$t('sideMenu.administration')"
                        v-if="claims.aspNetUser.read || claims.aspNetRole.read || claims.claimsAdministration.read || claims.applicationSettings.read
							|| claims.audit.read || claims.nomenclature.read || claims.nijData.read || claims.externalServices.read
							|| claims.notifications.read || claims.tasksAdministration.read || claims.coordinationsAdministration.read || claims.nomenclatureTypes.read
                            || claims.eventSubscriptions.read
							|| claims.documents.read || claims.releaseInfo.read || claims.email.read || claims.event.delete
                            || claims.help.create || claims.help.update || claims.reportsData.read
                            || claims.company.read || claims.deletedRecords.read || claims.signingAdministration.read"
                    >
                        <div slot="children">
                            <MenuItem
                                v-if="claims.aspNetUser.read"
                                to="/administration/users"
                                icon="fa-users"
                                index="/administration/users"
                            >{{$t('sideMenu.users')}}</MenuItem>
                            <MenuItem
                                v-if="claims.aspNetRole.read"
                                to="/administration/usergroups"
                                icon="fa-user-tag"
                                index="/administration/usergroups"
                            >{{$t('sideMenu.usergroups')}}</MenuItem>
                            <MenuItem
                                v-if="claims.claimsAdministration.read"
                                to="/administration/participantsClaims"
                                icon="fa-user-tag"
                                index="/administration/participantsClaims"
                            >{{$t('sideMenu.participantsClaims')}}</MenuItem>
                            <MenuItem
                                v-if="claims.applicationSettings.read"
                                to="/administration/applicationSettings"
                                icon="fa-cog"
                                index="/administration/applicationSettings"
                            >{{$t('sideMenu.applicationSettings')}}</MenuItem>
                            <MenuItem
                                v-if="claims.audit.read"
                                to="/administration/logs"
                                icon="fa-file-signature"
                                index="/administration/logs"
                            >{{$t('account.logs')}}</MenuItem>
                            <MenuItem
                                v-if="claims.nomenclature.read"
                                to="/administration/nomenclature"
                                icon="fa-list-ol"
                                index="/administration/nomenclature"
                            >{{$t('editor.dropdown.nomenclature')}}</MenuItem>
                            <MenuItem
                                v-if="claims.nomenclature.read"
                                to="/administration/foreignCities"
                                icon="fa-list-ol"
                                index="/administration/foreignCities"
                            >{{$t('registers.nomenclatures.foreignCities')}}</MenuItem>
                            <MenuItem
                                v-if="claims.nijData.read"
                                to="/administration/nipData"
                                icon="fas fa-database"
                                index="/administration/nipData"
                            >{{$t('nipData.companyData')}}</MenuItem>
                            <MenuItem
                                v-if="claims.externalServices.read"
                                to="/administration/externalServices"
                                icon="fas fa-sync-alt"
                                index="/administration/extrnalServices"
                            >{{$t('externalServices.title')}}</MenuItem>
                            <MenuItem
                                v-if="claims.notifications.read"
                                to="/administration/notifications"
                                icon="far fa-envelope"
                                index="/administration/notifications"
                            >{{$t('sideMenu.notifications')}}</MenuItem>
                            <MenuItem
                                v-if="claims.tasksAdministration.read"
                                to="/administration/tasks"
                                icon="far fa-tasks"
                                index="/administration/tasks"
                            >{{$t('sideMenu.tasks')}}</MenuItem>
                            <MenuItem
                                v-if="claims.coordinationsAdministration.read"
                                to="/administration/coordinations"
                                icon="far fa-sitemap"
                                index="/administration/coordinations"
                            >{{$t('sideMenu.coordinations')}}</MenuItem>
                            <MenuItem
                                v-if="claims.signingAdministration.read"
                                to="/administration/signatures"
                                icon="fa-file-signature"
                                index="/administration/signatures"
                            >{{$t('sideMenu.signatures')}}</MenuItem>
                            <MenuItem
                                v-if="claims.company.read"
                                to="/company/list"
                                icon="far fa-building"
                                index="/company/list"
                            >{{$t('sideMenu.company')}}</MenuItem>
                            <MenuGroup
                                v-if="claims.nomenclatureTypes.read"
                                icon="fa-list-ol"
                                :title="$t('sideMenu.nomenclatureTypes')"
                            >
                                <div slot="children">
                                    <MenuItem
                                        to="/administration/participationType"
                                        index="/administration/participationType"
                                    >{{$t('sideMenu.participationType')}}</MenuItem>
                                    <MenuItem
                                        to="/administration/participationRelationType"
                                        index="/administration/participationRelationType"
                                    >{{$t('sideMenu.participationRelationType')}}</MenuItem>
                                    <MenuItem
                                        to="/administration/benchmarkType"
                                        index="/administration/benchmarkType"
                                    >{{$t('sideMenu.benchmarkType')}}</MenuItem>
                                    <MenuItem
                                        to="/administration/reasonForAdmission"
                                        index="/administration/reasonForAdmission"
                                    >{{$t('sideMenu.reasonForAdmission')}}</MenuItem>
                                    <MenuItem
                                        to="/administration/eventStatus"
                                        index="/administration/eventStatus"
                                    >{{$t('sideMenu.eventStatus')}}</MenuItem>
                                </div>
                            </MenuGroup>
                            <MenuGroup
                                v-if="claims.deletedRecords.read"
                                icon="fa-list-ol"
                                :title="$t('sideMenu.deletedRecords')"
                            >
                                <div slot="children">
                                    <MenuItem
                                        to="/administration/deletedRecords/lecturers"
                                        index="/administration/deletedRecords/lecturers"
                                    >
                                        {{$t('sideMenu.lectors')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/places"
                                        index="/administration/deletedRecords/places"
                                    >
                                        {{$t('places.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/accommodationPlaces"
                                        index="/administration/deletedRecords/accommodationPlaces"
                                    >
                                        {{$t('registers.accommodation.menuTitle')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/projects"
                                        index="/administration/deletedRecords/projects"
                                    >
                                        {{$t('project.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/publicOrders"
                                        index="/administration/deletedRecords/publicOrders"
                                    >
                                        {{$t('registers.publicOrder.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/activities"
                                        index="/administration/deletedRecords/activities"
                                    >
                                        {{$t('activity.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/thematicAreas"
                                        index="/administration/deletedRecords/thematicAreas"
                                    >
                                        {{$t('thematicArea.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/institutions"
                                        index="/administration/deletedRecords/institutions"
                                    >
                                        {{$t('institution.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/administrativePositions"
                                        index="/administration/deletedRecords/administrativePositions"
                                    >
                                        {{$t('administrativePosition.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/deletedEvents"
                                        index="/administration/deletedRecords/deletedEvents"
                                    >
                                        {{$t('registers.events.title')}}
                                    </MenuItem>
                                    <MenuItem
                                        to="/administration/deletedRecords/documents"
                                        index="/administration/deletedRecords/documents"
                                    >
                                        {{$t('documents')}}
                                    </MenuItem>

                                </div>
                            </MenuGroup>
                            <MenuItem
                                v-if="claims.eventSubscriptions.read"
                                to="/administration/eventSubscriptions"
                                icon="fa-check-square"
                                index="/administration/eventSubscriptions"
                            >{{$t('sideMenu.eventSubscriptions')}}</MenuItem>
                            <MenuItem
                                v-if="claims.documents.read"
                                to="/documentsRelation"
                                icon="fas fa-file-download"
                                index="/documentsRelation"
                            >{{$t('sideMenu.documents')}}</MenuItem>
                            <MenuItem
                                v-if="claims.email.read"
                                to="/administration/emails"
                                icon="far fa-envelope"
                                index="/administration/emails"
                            >{{$t('sideMenu.sentEmails')}}</MenuItem>
                            <MenuItem
                                v-if="claims.event.delete"
                                to="/administration/archivedEvents"
                                icon="fas fa-archive"
                                index="/administration/archivedEvents"
                            >{{$t('sideMenu.archivedEvents')}}</MenuItem>
                            <MenuItem
                                v-if="claims.releaseInfo.read"
                                to="/administration/releaseInfo"
                                icon="far fa-tasks"
                                index="/administration/releaseInfo"
                            >{{$t('sideMenu.releaseInfo')}}</MenuItem>
                            <MenuItem
                                v-if="claims.reportsData.read"
                                to="/administration/migrationCheck"
                                icon="far fa-tasks"
                                index="/administration/migrationCheck"
                            >{{$t('sideMenu.migrationCheck')}}</MenuItem>
                            <!--<MenuItem
                                v-if="claims.help.create || claims.help.update"
                                to="/help/edit"
                                icon="far fa-question-circle"
                                index="/help/edit"
                            >{{$t('sideMenu.help')}}</MenuItem>-->
                        </div>
                    </MenuGroup>
                    <MenuGroup
                        v-if="claims.dynamicRegister.read || claims.auxiliaryRegister.read || claims.auxiliaryRegister.create || claims.auxiliaryRegister.update"
                        icon="fa-cog"
                        :title="$t('sideMenu.dynamicRegisters')"
                    >
                        <div slot="children">
                            <MenuItem
                                to="/dynamic/list"
                                icon="fa-list"
                                index="/dynamic/list"
                            >{{$t('registers.dynamic.title')}}</MenuItem>
                            <MenuItem
                                to="/dynamic/fieldDetails"
                                icon="fa-columns"
                                index="/dynamic/fieldDetails"
                            >{{$t('sideMenu.panelsFields')}}</MenuItem>
                            <MenuGroup :bold="true" :title="$t('sideMenu.forms')">
                                <div slot="children">
                                    <MenuItem
                                        to="/forms/templates"
                                        icon="fas fa-stream"
                                        index="/forms"
                                    >{{$t('sideMenu.templates')}}</MenuItem>
                                    <MenuItem
                                        to="/forms"
                                        icon="fa-list"
                                        index="/forms"
                                    >{{$t('sideMenu.forms')}}</MenuItem>
                                    <MenuItem
                                        to="/forms/fieldDetails"
                                        icon="fa-columns"
                                        index="/forms/fieldDetails"
                                    >{{$t('sideMenu.panelsFields')}}</MenuItem>
                                    <MenuItem
                                        to="/forms/summaryReport"
                                        icon="far fa-file-word"
                                        index="/forms/summaryReport"
                                    >{{$t('sideMenu.summaryFormsReport')}}</MenuItem>
                                </div>
                            </MenuGroup>
                            <MenuGroup :bold="true" :title="$t('sideMenu.auxiliaryRegister')" v-if="claims.auxiliaryRegister.read || claims.auxiliaryRegister.create || claims.auxiliaryRegister.update">
                                <div slot="children">
                                    <MenuItem v-if="claims.auxiliaryRegister.read"
                                              to="/auxiliary/list"
                                              icon="fa-list"
                                              index="/auxiliary/list">
                                        {{$t('sideMenu.list')}}
                                    </MenuItem>
                                    <MenuItem v-if="claims.auxiliaryRegister.create || claims.auxiliaryRegister.update"
                                              to="/auxiliary/fieldDetails"
                                              icon="fa-columns"
                                              index="/forms/fieldDetails">
                                        {{$t('sideMenu.panelsFields')}}
                                    </MenuItem>
                                </div>
                            </MenuGroup>
                            <MenuItem
                                to="/dynamic/fieldTypes"
                                icon="fa-cog"
                                index="/dynamic/fieldTypes"
                            >{{$t('sideMenu.fieldTypes')}}</MenuItem>
                            <MenuItem
                                to="/dynamic/staticRegistersForDropdown"
                                icon="fa-cog"
                                index="/dynamic/staticRegistersForDropdown"
                            >{{$t('sideMenu.staticRegistersForDropdown')}}</MenuItem>
                            <MenuItem
                                to="/dynamic/fieldCodes"
                                icon="fa-tags"
                                index="/dynamic/fieldCodes"
                            >{{$t('sideMenu.fieldCodes')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuItem
                        v-if="claims.presence.read"
                        to="/presenceForm"
                        icon="fa-list-ol"
                        index="/presenceForm"
                    >{{$t('sideMenu.presenceForm')}}</MenuItem>
                    <MenuItem
                        v-if="claims.tariff.read"
                        to="/tariffGroups"
                        icon="fa-wallet"
                        index="/tariffGroups"
                    >{{$t('sideMenu.tariffs')}}</MenuItem>
                    <MenuGroup
                        v-if="claims.formSurvey.read"
                        icon="fa-file-invoice"
                        :title="$t('sideMenu.formsAndSurveys')"
                    >
                        <div slot="children">
                            <MenuItem
                                to="/forms/active"
                                icon="fa-unlock"
                                index="/forms/active"
                            >{{$t('registers.forms.active')}}</MenuItem>
                            <MenuItem
                                to="/forms/my"
                                icon="fa-portrait"
                                index="/forms/my"
                            >{{$t('registers.forms.my')}}</MenuItem>
                            <MenuItem
                                v-if="claims.formSurvey.create || claims.formSurvey.update || claims.formSurvey.delete"
                                to="/forms/all"
                                icon="fa-list-ol"
                                index="/forms/all"
                            >{{$t('sideMenu.all')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuItem
                        v-if="claims.calendar.read"
                        to="/calendar"
                        icon="fa-calendar-alt"
                        index="/calendar"
                    >{{$t('calendar.title')}}</MenuItem>
                    <MenuGroup
                        v-if="claims.reportsData.read"
                        icon="fas fa-database"
                        :title="$t('sideMenu.reportData')"
                    >
                        <div slot="children">
                            <MenuItem
                                v-if="claims.reportsData.read"
                                to="/reportData/events"
                                icon="fa-calendar-check"
                                index="/reportData/events"
                            >{{$t('reportData.events.menuTitle')}}</MenuItem>
                            <MenuItem
                                v-if="claims.reportsData.read"
                                to="/reportData/participants"
                                icon="fas fa-list"
                                index="/reportData/participants"
                            >{{$t('reportData.participants.menuTitle')}}</MenuItem>
                        </div>
                    </MenuGroup>
                    <MenuItem
                        v-if="claims.lecturersElRegister.read"
                        icon="fas fa-chalkboard-teacher"
                        to="/lecturersElRegister"
                        index="/lecturersElRegister"
                    >{{$t('sideMenu.lecturersElectronicRegister')}}</MenuItem>
                    <MenuItem
                        v-if="claims.forum.read"
                        link="https://isupo.nij.bg/forum"
                        icon="far fa-newspaper"
                        index="https://isupo.nij.bg/forum"
                    >{{$t('sideMenu.forum')}}</MenuItem>
                </div>
            </div>
        </SideBar>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SideBar from "./sidebar.vue";
import MenuItem from "./menu-item.vue";
import MenuGroup from "./menu-group.vue";

export default {
    components: {
        SideBar,
        MenuItem,
        MenuGroup,
    },
    data() {
        return {
            isOpened: false
        };
    },
    methods: {
        onClose() {
            this.$store.dispatch("setSideMenuVisibility", false);
        },
        navigateToReports() {
            if (!this.isAuthenticated || !this.claims.reports.read) {
                return this.$router.push(`/unauthorized`);
            }

            const url = `${this.baseUrl}/reports`;
            this.$cookie.set('ReportServerCookie', this.authToken, 1);
            window.open(url, '_blank');
        }
    },
    computed: {
        ...mapGetters([
            "activeRoute",
            "sidemenu",
            "isAuthenticated",
            "userName",
            "baseUrl",
            "claims",
            'authToken'
        ]),
    },
    watch: {
        activeRoute: function (newVal) {
            this.$refs.sidebar.setActiveIndex(newVal.path);
        },
    },
};
</script>

<style lang="scss" scoped>
.user-info {
    display: flex;
    align-items: center;
}
</style>
